import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useRef, useLayoutEffect } from 'react';
import { getScrollParent } from 'utils/ui';
function useIsElementInView() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$initialValue = _ref.initialValue,
    initialValue = _ref$initialValue === void 0 ? false : _ref$initialValue,
    rootRef = _ref.rootRef;
  var _useState = useState(initialValue),
    _useState2 = _slicedToArray(_useState, 2),
    isInView = _useState2[0],
    setIsInView = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    watchedElement = _useState4[0],
    setWatchedElement = _useState4[1];
  var observerRef = useRef(null);
  useLayoutEffect(function () {
    // Bail out early if IntersectionObserver isn't supported
    if (!watchedElement || !('IntersectionObserver' in window)) {
      return;
    }

    // Assign the IntersectionObserver to a ref so we don't
    // need to re-create it when the effect reruns
    if (!observerRef.current) {
      var root = (rootRef === null || rootRef === void 0 ? void 0 : rootRef.current) || getScrollParent(watchedElement) || null;
      observerRef.current = new IntersectionObserver(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
          entry = _ref3[0];
        setIsInView(entry.isIntersecting);
      }, {
        // For some reason, passing the actual document root as the
        // root parameter breaks the intersection observer. We set it
        // to `null` in this case, which seems to always work.
        root: root === document.scrollingElement ? null : root
      });
    }
    observerRef.current.observe(watchedElement);
    return function () {
      if (observerRef.current) {
        observerRef.current.unobserve(watchedElement);
      }
    };
  }, [watchedElement, rootRef]);
  return {
    // Is the watched element in view
    isInView: isInView,
    // A ref function to be passed to the element we want to observe
    watchedElementRef: setWatchedElement
  };
}
export default useIsElementInView;